import React, { useEffect, useState } from 'react'
import adminServices from '../../services/AdminServices';
import OrderModal from '../orders/OrderModal';
import Empty from '../feedback/Empty';
import moment from 'moment';
import utils from '../../utils';
import Loading from '../feedback/Loading';
import FetchError from '../feedback/FetchError';
import { MdOutlineRestore } from 'react-icons/md';

function OrdersPreview() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activePayment, setActivePayment] = useState(null);
    const [payments, setPayments] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        getPayments()
    }, [])

    const getPayments = () => {
        adminServices.getPurchases('').then(
            (res) => {
                setPayments(res.data);
                setLoading(false);
            },
            (err) => {
                console.error('Failed to fetch payments:', err);
                setError(err);
                setLoading(false);
            }
        )
    }
    const openModal = (payment) => {
        setActivePayment(payment);
        setIsModalOpen(true);
    }

    function onClose() {
        setIsModalOpen(false);
        setActivePayment(null);
    }
    return (
        <div className='space-y-6'>
            <h3 className="text-2xl font-bold text-gray-800 flex gap-3 items-center">
                <MdOutlineRestore className='h-7 w-7' /> Recent Orders
            </h3>
            <OrderModal
                payment={activePayment}
                isOpen={isModalOpen}
                onClose={onClose}
                getPayments={getPayments}
            />
            {loading ? (
                <div className="py-9">
                    <Loading />
                </div>
            ) : error ? (
                <FetchError error={error} />
            ) : (
                <div className='p-3 bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark'>
                    <div className='overflow-x-hidden'>
                        <table className="table table-compact table-zebra w-full">
                            <thead>
                                <tr>
                                    <th>Customer</th>
                                    <th className='hidden md:table-cell'>Purchases</th>
                                    <th>Price (KSH)</th>
                                    <th className='hidden md:table-cell'>Method</th>
                                    <th className='hidden md:table-cell'>Status</th>
                                    <th className='hidden md:table-cell'>Created</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {payments?.results.slice(0, 5)?.map((payment, idx) => (
                                    <tr key={idx}>
                                        <td className='font-bold'>{payment?.customer_profile?.full_name}</td>
                                        <td className='hidden md:table-cell'>
                                            {
                                                payment?.get_cart_items?.reduce((accumulator, item) => {
                                                    return accumulator + item.quantity;
                                                }, 0)
                                            }
                                        </td>
                                        <td className='font-bold'>{utils.toCommas(payment?.total)}</td>
                                        <td className='hidden md:table-cell'>{payment?.payment_method}</td>
                                        <td className='hidden md:table-cell'>{payment?.status}</td>
                                        <td className='font-bold hidden md:table-cell'>{moment(payment?.creation_time).format("MMMM Do YYYY")}</td>
                                        <td>
                                            <button
                                                onClick={() => openModal(payment)}
                                                className='btn btn-sm btn-primary'>View</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {payments?.count < 1 ? (
                            <Empty objectName={"Recent Payments"} />
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    )
}

export default OrdersPreview